/* src/app/views/area-publica/detalhes-projeto/project-details-analise-public/project-details-analise-public.component.scss */
.analise {
  margin: 3% auto;
  margin-top: 0;
}
.analise th {
  font-size: 14px;
  font-weight: 600;
  color: #15BEA8;
  padding: 0 5px;
}
.analise tr:not(:first-child) > td {
  padding: 10px;
}
.analise tr:nth-child(n+2) > td:nth-child(n+2):not(:last-child) {
  border-right: 2px solid #F0F0F0;
  width: 15%;
}
.analise tr:nth-child(n+2):not(:last-child) > td:nth-child(n+2) {
  border-bottom: 2px solid #F0F0F0;
  width: 15%;
}
.analise td {
  text-align: center;
}
.analise tr > td:first-child {
  font-size: 16px;
  font-weight: 600;
  color: #D08001;
  text-align: end;
}
.analise .check-orange {
  color: #D08001;
  opacity: 0.3;
}
.analise .check-green {
  color: #15BEA8;
  opacity: 0.3;
}
.analise .checked {
  opacity: 1 !important;
}
.analise .legend {
  font-size: 14px;
  font-weight: 500;
  margin: 0 13% 0 53%;
  color: #2E3241;
}
/*# sourceMappingURL=project-details-analise-public.component.css.map */
